import HeroPost from './hero-post'

export default HeroPost
